// Product Images - Organized by category
export const productImages = {
  // Featured Products (Priority)
  'Cention  Syestem Kit': '/images/products/Cention  Syestem Kit.png',
  'cembest': '/images/products/cembest.png',
  'Italgin chromatic': '/images/products/Italgin chromatic.png',
  'Te-Econom': '/images/products/Te-Econom.png',
  
  // Cention Products
  'cention-n': '/images/products/cention n.png',
  'cention-forte-capsules-a2': '/images/products/Cention Forte Capsule....3g.png',
  'cention-forte-capsules-a3': '/images/products/Cention Forte Capsule....3g.png',
  'cention-primer': '/images/products/Cention Primer 6g.png',
  'cention-syestem-kit': '/images/products/Cention n  Syestem Kit.png',
  'cention-forte-capsules-a2-50': '/images/products/Cention Forte Capsules A2 50 x 0.3g.png',
  
  // Dental Materials
  'a2-dentin': '/images/products/A2 Dentin.png',
  'te-econom-bond': '/images/products/Te-Econom Bond.png',
  'fluor-protector-gel': '/images/products/Fluor Protector Gel.png',
  'fluor-protector': '/images/products/Fluor Protector.png',
  'fillbest': '/images/products/Fillbest.png',
  'gypsum': '/images/products/Gypsum.png',
  'modelling-wax': '/images/products/Modelling Wax.png',
  'prothesis-mobile-wax': '/images/products/Prothesis Mobile Wax.png',
  'proxem-rc-filling': '/images/products/ProXem  RC Filling.png',
  'proxem-temp-luting': '/images/products/ProXem  Temp- Luting.png',
  'proxem-ch-liner': '/images/products/Proxem CH Liner.png',
  'proxem': '/images/products/ProXem.png',
  'silikit': '/images/products/Silikit.png',
  'vinylkit': '/images/products/Vinylkit.png',
  'tempolary-filling': '/images/products/Tempolary filling.png',
  'cervitec-f': '/images/products/Cervitec F.png',
  'cervitec-gel': '/images/products/Cervitec Gel.png',
  
  // Equipment & Tools
  'bluephase-n-g4': '/images/products/Bluephase N G4 100-240V.png',
  'optragate-regular': '/images/products/OptraGate Regular.png',
  'optragate-small': '/images/products/Optragate small.png',
  'optragate': '/images/products/Optragate.png',
  'optra-sculpt': '/images/products/OptraSculpt.png',
  'saliva-ejector': '/images/products/Saliva Ejector.png',
  'latex-free-lip-cheek': '/images/products/Latex-free lip and cheek.png',
  'articulating-paper': '/images/products/Articulating paper.png',
  'autosealing-pouches': '/images/products/autosealing-pouches.png',
  '140mm-x-250mm': '/images/products/140mm x 250mm.png',
  '50-capsules-50-restorations': '/images/products/50 Capsules for 50+ Restorations.png',
  
  // Placeholder for products without images
  'default': '/images/products/default-product.svg'
};

// Helper function to get product image
export const getProductImage = (productSlug: string): string => {
  return productImages[productSlug as keyof typeof productImages] || productImages.default;
};

// Product image mapping for database products
export const productImageMap: Record<string, string> = {
  // Featured Products (Priority)
  'cention-system-kit': 'Cention  Syestem Kit',
  'cention-syestem-kit': 'Cention  Syestem Kit',
  'cembest': 'cembest',
  'italgin-chromatic': 'Italgin chromatic',
  'te-econom': 'Te-Econom',
  
  // Cention Products
  'cention-n': 'cention-n',
  'cention-forte-capsules-a2': 'cention-forte-capsules-a2',
  'cention-forte-capsules-a3': 'cention-forte-capsules-a3',
  'cention-primer': 'cention-primer',
  // keep only one mapping for cention system kit (above)
  'cention-forte-capsules-a2-50': 'cention-forte-capsules-a2-50',
  
  // Dental Materials
  'a2-dentin': 'a2-dentin',
  'te-econom-bond': 'te-econom-bond',
  'fluor-protector-gel': 'fluor-protector-gel',
  'fluor-protector': 'fluor-protector',
  'fillbest': 'fillbest',
  'gypsum': 'gypsum',
  'modelling-wax': 'modelling-wax',
  'prothesis-mobile-wax': 'prothesis-mobile-wax',
  'proxem-rc-filling': 'proxem-rc-filling',
  'proxem-temp-luting': 'proxem-temp-luting',
  'proxem-ch-liner': 'proxem-ch-liner',
  'proxem': 'proxem',
  'silikit': 'silikit',
  'vinylkit': 'vinylkit',
  'tempolary-filling': 'tempolary-filling',
  'cervitec-f': 'cervitec-f',
  'cervitec-gel': 'cervitec-gel',
  
  // Equipment & Tools
  'bluephase-n-g4': 'bluephase-n-g4',
  'optragate-regular': 'optragate-regular',
  'optragate-small': 'optragate-small',
  'optragate': 'optragate',
  'optra-sculpt': 'optra-sculpt',
  'optrascalpt': 'optra-sculpt', // Handle slug generation from "OptraSculpt"
  'saliva-ejector': 'saliva-ejector',
  'latex-free-lip-and-cheek': 'latex-free-lip-cheek',
  'articulating-paper': 'articulating-paper',
  'autosealing-pouches': 'autosealing-pouches',
  '140mm-x-250mm': '140mm-x-250mm',
  '50-capsules-for-50-restorations': '50-capsules-50-restorations',
  
  // Direct product name mappings
  'OptraSculpt': 'optra-sculpt',
  'OptraGate': 'optragate',
  'OptraGate Small': 'optragate-small',
  'OptraGate Regular': 'optragate-regular',
  
  // Additional slug variations for Optra products
  // removed duplicates for optragate keys
  
  // General mappings
  'ivoclar': 'a2-dentin',
  'vatech': 'bluephase-n-g4',
  'bms': 'optragate'
};
